import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const ContactListFilters = ({ 
  filters = {},
  onFiltersChange,
  onClose,
  className = ''
}) => {
  const [localFilters, setLocalFilters] = useState(filters);

  const monthOptions = [
    { value: '', label: 'All Months' },
    { value: '1', label: 'January' },
    { value: '2', label: 'February' },
    { value: '3', label: 'March' },
    { value: '4', label: 'April' },
    { value: '5', label: 'May' },
    { value: '6', label: 'June' },
    { value: '7', label: 'July' },
    { value: '8', label: 'August' },
    { value: '9', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' }
  ];

  const activityOptions = [
    { value: '', label: 'All Activity' },
    { value: 'today', label: 'Contacted Today' },
    { value: 'week', label: 'This Week' },
    { value: 'month', label: 'This Month' },
    { value: 'never', label: 'Never Contacted' }
  ];

  const handleFilterChange = (key, value) => {
    setLocalFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handleApplyFilters = () => {
    onFiltersChange(localFilters);
    onClose();
  };

  const handleClearFilters = () => {
    setLocalFilters({});
    onFiltersChange({});
    onClose();
  };

  return (
    <div className={`bg-surface border border-border rounded-lg shadow-modal ${className}`}>
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-border">
        <h3 className="text-lg font-semibold text-text-primary">
          Filter Contacts
        </h3>
        <Button
          variant="ghost"
          size="icon"
          onClick={onClose}
        >
          <Icon name="X" size={20} />
        </Button>
      </div>
      {/* Filter Options */}
      <div className="p-4 space-y-6">
        {/* Birthday Month */}
        <div>
          <Select
            label="Birthday Month"
            options={monthOptions}
            value={localFilters?.birthdayMonth || ''}
            onChange={(value) => handleFilterChange('birthdayMonth', value)}
            placeholder="Select month..."
          />
        </div>

        {/* Recent Activity */}
        <div>
          <Select
            label="Recent Activity"
            options={activityOptions}
            value={localFilters?.recentActivity || ''}
            onChange={(value) => handleFilterChange('recentActivity', value)}
            placeholder="Select activity..."
          />
        </div>

        {/* Company */}
        <div>
          <Input
            label="Company"
            type="text"
            placeholder="Filter by company..."
            value={localFilters?.company || ''}
            onChange={(e) => handleFilterChange('company', e?.target?.value)}
          />
        </div>

        {/* Location */}
        <div>
          <Input
            label="Location"
            type="text"
            placeholder="Filter by location..."
            value={localFilters?.location || ''}
            onChange={(e) => handleFilterChange('location', e?.target?.value)}
          />
        </div>

        {/* Tags */}
        <div>
          <Input
            label="Tags"
            type="text"
            placeholder="Filter by tags (comma separated)..."
            value={localFilters?.tags ? localFilters?.tags?.join(', ') : ''}
            onChange={(e) => {
              const tags = e?.target?.value?.split(',')?.map(tag => tag?.trim())?.filter(tag => tag);
              handleFilterChange('tags', tags);
            }}
          />
        </div>

        {/* Checkboxes */}
        <div className="space-y-3">
          <Checkbox
            label="Favorites only"
            checked={localFilters?.favorites || false}
            onChange={(e) => handleFilterChange('favorites', e?.target?.checked)}
          />
          
          <Checkbox
            label="Has birthday this month"
            checked={localFilters?.birthdayThisMonth || false}
            onChange={(e) => handleFilterChange('birthdayThisMonth', e?.target?.checked)}
          />
          
          <Checkbox
            label="Has phone number"
            checked={localFilters?.hasPhone || false}
            onChange={(e) => handleFilterChange('hasPhone', e?.target?.checked)}
          />
          
          <Checkbox
            label="Has email address"
            checked={localFilters?.hasEmail || false}
            onChange={(e) => handleFilterChange('hasEmail', e?.target?.checked)}
          />
        </div>
      </div>
      {/* Actions */}
      <div className="flex items-center justify-between p-4 border-t border-border">
        <Button
          variant="outline"
          onClick={handleClearFilters}
        >
          Clear All
        </Button>
        
        <div className="flex items-center space-x-2">
          <Button
            variant="ghost"
            onClick={onClose}
          >
            Cancel
          </Button>
          
          <Button
            variant="default"
            onClick={handleApplyFilters}
          >
            Apply Filters
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ContactListFilters;